import { ApiResult, request, safeRequest } from '@synergy/api';
import { StaticSiteDto } from '@synergy/models';
import urlJoin from 'url-join';

export class StaticSitesApi {
    constructor(protected baseUrl: string) {}

    public getStaticSite = (path: string): Promise<ApiResult<StaticSiteDto>> => {
        const url = urlJoin(this.baseUrl, '/static-sites', path);
        return safeRequest(
            () => request.get(url),
            response => response.data
        );
    };
}
